export const MVP_SESSION_TYPES = [
  'Hands-on Desk',
  'Face Close-up',
  'Upper Body',
  'Full Body Moving',
  'Digital Skills',
];

export const MVP_SESSION_TYPE_OPTIONS = MVP_SESSION_TYPES.map((value) => ({
  value,
  label: value,
}));
